@import './constants';
@import '../common/salesscreen-colors.less';
@import '../common/salesscreen-text.less';

@keyframes shake {
    10%,
    90% {
        transform: translate3d(-1px, 0, 0);
    }
    20%,
    80% {
        transform: translate3d(2px, 0, 0);
    }
    30%,
    50%,
    70% {
        transform: translate3d(-4px, 0, 0);
    }
    40%,
    60% {
        transform: translate3d(4px, 0, 0);
    }
}

a {
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    &:hover {
        cursor: pointer;
    }
    &:active,
    &:hover,
    &:focus,
    &:visited {
        color: @eastern-blue;
    }
}

.hidden {
    display: none;
}

.bold {
    font-weight: 700;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.marginBottom {
    margin-bottom: 20px;
}

.tac {
    text-align: center;
}

.vat {
    vertical-align: top;
}

.vac {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

.dib {
    display: inline-block;
}

.background-contain {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}

.loginHtml {
    height: 100%;
    width: 100%;
    background-color: var(--color-neutral-10);
    background-repeat: no-repeat no-repeat;
    background-position: center;
    background-size: cover;
    body {
        height: 100%;
        width: 100%;
        margin: 0;
    }
}

.loginWrapper {
    width: 100%;
    height: 100%;
}

.loginActions.twoFactorAuthentication {
    .twoFactorInputContainer {
        margin-top: 20px;
    }
    .twoFactorRememberBrowserContainer {
        margin-bottom: 20px;
        input {
            vertical-align: -2px;
        }
    }
    .twoFactorErrorContainer {
        margin-top: 12px;
    }
    .twoFactorContentContainer {
        width: 100%;
        a {
            color: @eastern-blue;
        }
        &.hidden {
            display: none;
        }
        .twoFactorProviders {
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;
            text-align: center;

            .twoFactorProviderOuterContainer {
                cursor: pointer;
                display: inline-block;
                margin-left: 15px;
                margin-right: 15px;
                .twoFactorProviderIconContainer {
                    padding: 5px;
                    border: 2px solid white;
                    border-radius: 50%;
                    .twoFactorProviderImg {
                        display: block;
                        width: 96px;
                        height: 96px;
                    }
                    &.active {
                        border: 2px solid @shamrock;
                        border-radius: 50%;
                    }
                }

                .twoFactorProviderTitle {
                    margin-top: 10px;
                    font-size: 14px;
                    font-weight: 700;
                    text-transform: uppercase;
                }
            }
        }
        .twoFactorProviderDesc {
            margin-bottom: 20px;
            &.hidden {
                display: none;
            }
        }
        .twoFactorProviderButtonContainer {
            &.hidden {
                display: none;
            }
        }
        .twoFactorText {
            margin-bottom: 20px;
        }
        .phoneInputContainer {
            position: relative;
            width: 100%;
            .phoneCountryWrapper {
                display: inline-block;
                width: 30%;
                select {
                    font-size: 15px;
                }
            }
            .phoneNumberWrapper {
                position: absolute;
                right: 0;
                display: inline-block;
                width: 65%;
            }
        }
    }
    .twoFactorLoadingContainer {
        &.hidden {
            display: none;
        }
    }
}

.loginComponentWrapper {
    .loginFrame {
        .loginActionsColumn,
        .ssoFailed {
            .loginActions {
                width: 100%;
                display: inline-block;
                .inputFieldWrapper {
                    position: relative;
                }
                .signInHeading {
                    font-size: 20px;
                    margin-bottom: 20px;
                    font-weight: 700;
                }
                input[type='text'],
                input[type='email'],
                input[type='password'],
                input[type='tel'],
                input[type='number'],
                select {
                    width: 100%;
                    height: 40px;
                    margin-bottom: 20px;
                    margin-top: 8px;
                    font-size: 18px;
                }
                select {
                    padding: 0 5px;
                }
                .buttonBlock {
                    font-weight: 700;
                    font-size: 14px;
                    display: block;
                    width: 100%;
                    padding: 10px 12px;
                    background-color: var(--color-brand-primary);
                    border: none;
                    height: 40px;
                    color: #ffffff;
                    text-align: center;
                    border-radius: 4px;
                    text-transform: uppercase;
                    transition: all 0.15s ease;
                }
                .buttonBlock.secondary {
                    background-color: @silver;
                }
                .buttonBlock:disabled,
                .buttonBlock.secondary:disabled {
                    background-color: @mercury;
                    cursor: not-allowed;
                }
                .buttonBlock:hover:enabled,
                .buttonBlock:active:enabled,
                .buttonBlock.active:enabled {
                    background-color: var(--color-teal-40);
                    cursor: pointer;
                }
                .buttonBlock.secondary:hover:enabled,
                .buttonBlock.secondary:active:enabled,
                .buttonBlock.secondary.active:enabled {
                    background-color: @mercury;
                    cursor: pointer;
                }
                .loading-wrapper {
                    position: absolute;
                    bottom: 40px;
                    left: 0;
                    width: 100%;
                }
                .passwordBreachWarning {
                    padding-bottom: 24px;
                }
            }
            .forgotLink {
                color: #333;
                font-weight: 500;
                position: absolute;
                right: 60px;
                top: 28px;
                line-height: 38px;
                text-decoration: none;
            }
            .forgotLink:hover {
                text-decoration: underline;
            }
            .backToLogin {
                font-weight: 400;
                text-decoration: none;
                color: black;
                margin-top: 24px;
                display: inline-block;
                &.backToLoginBold {
                    font-weight: 600;
                }
            }
            .backToLogin:hover,
            .backToLogin.active,
            .backToLogin:active {
                font-weight: 600;
            }
            .forgotPasswordButton {
                text-transform: uppercase;
                display: block;
                text-decoration: none;
                width: 100%;
                text-align: center;
                padding: 21px 0px;
                font-size: 14px;
                background-color: #f2f2f2;
                color: #333333;
                transition: all 0.15s ease;
            }
            .forgotPasswordButton:hover,
            .forgotPasswordButton:active,
            .forgotPasswordButton.active {
                background-color: #ccc;
                cursor: pointer;
            }
        }
    }
}

.loadingIcon {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    .barLoader {
        padding: 0px;
        position: absolute;
        z-index: 3;
        margin: 0 auto;
        left: 0;
        right: 0;
        top: 50%;
        width: 60px;
        height: 60px;
        list-style: none;
        &.small {
            width: 30px;
            height: 30px;
            li {
                width: 5px;
                height: 5px;
                margin-right: 2.5px;
                box-shadow: 0px 50px 10px rgba(0, 0, 0, 0.2);
            }
            li:first-child {
                animation: loadbarsSmall 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) infinite 0s;
                -webkit-animation: loadbarsSmall 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) infinite
                    0s;
            }
            li:nth-child(2) {
                animation: loadbarsSmall 0.6s ease-in-out infinite -0.2s;
                -webkit-animation: loadbarsSmall 0.6s ease-in-out infinite -0.2s;
            }
            li:nth-child(3) {
                animation: loadbarsSmall 0.6s ease-in-out infinite -0.4s;
                -webkit-animation: loadbarsSmall 0.6s ease-in-out infinite -0.4s;
            }
        }
        li {
            background-color: @eastern-blue;
            width: 10px;
            height: 10px;
            float: right;
            margin-right: 5px;
            box-shadow: 0px 100px 20px rgba(0, 0, 0, 0.2);
        }
        li:first-child {
            animation: loadbars 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) infinite 0s;
            -webkit-animation: loadbars 0.6s cubic-bezier(0.645, 0.045, 0.355, 1) infinite 0s;
        }
        li:nth-child(2) {
            animation: loadbars 0.6s ease-in-out infinite -0.2s;
            -webkit-animation: loadbars 0.6s ease-in-out infinite -0.2s;
        }
        li:nth-child(3) {
            animation: loadbars 0.6s ease-in-out infinite -0.4s;
            -webkit-animation: loadbars 0.6s ease-in-out infinite -0.4s;
        }
    }
    @-webkit-keyframes loadbars {
        0% {
            height: 10px;
            margin-top: 25px;
        }
        50% {
            height: 50px;
            margin-top: 0px;
        }
        100% {
            height: 10px;
            margin-top: 25px;
        }
    }
    @keyframes loadbars {
        0% {
            height: 10px;
            margin-top: 25px;
        }
        50% {
            height: 50px;
            margin-top: 0px;
        }
        100% {
            height: 10px;
            margin-top: 25px;
        }
    }
    @-webkit-keyframes loadbarsSmall {
        0% {
            height: 5px;
            margin-top: 12.5px;
        }
        50% {
            height: 25px;
            margin-top: 0px;
        }
        100% {
            height: 5px;
            margin-top: 12.5px;
        }
    }
    @keyframes loadbarsSmall {
        0% {
            height: 5px;
            margin-top: 12.5px;
        }
        50% {
            height: 25px;
            margin-top: 0px;
        }
        100% {
            height: 5px;
            margin-top: 12.5px;
        }
    }
}
